module.exports = __webpack_public_path__ + "img/xrp-secret-input.af6f849e.png";